<template>
    <select-label
        v-model="category"
        :disabled="isDisabled"
        :editable="isEditable"
        :items="categories"
        :label="label"
        :append-icon="isDisabled ? '' : '$vuetify.icons.dropdown'"
        item-text="text"
        item-value="value"
    />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { AppContext } from '../../store/context';
const Categories = AppContext.SystemChangeHistoryCategory;
import SelectLabel from './SelectLabel.vue';

@Component({
    name: 'SelectorSystemChangeHistoryCategory',
    components: {
        SelectLabel,
    },
})
export default class SelectorSystemChangeHistoryCategory extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: undefined }) label: string;
    @Watch('value', { immediate: true })
    onValueChanged(val: string): void {
        this.category = val;
    }
    @Watch('category', { immediate: true })
    onCategoryChanged(val: string): void {
        this.input(val);
    }
    @Emit()
    public input(value: string) {}

    categories = [];
    category = '';

    created() {
        this.categories = Categories.map(kv => {
            return { text: (this as any).$t(kv.text_key), value: kv.value };
        });
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get isEditable(): boolean {
        return this.editable;
    }
}
</script>
